import React, { useContext } from 'react'
import { DropdownContentProps } from './Dropdown.types'

import DropdownContext from './DropdownContext'
import { StyledDropdownContent } from './styled'

const DropdownContent: React.FC<DropdownContentProps> = ({
  overrideWidth = false,
  positionDropdown = 'right',
  ...restProps
}) => {
  const { show } = useContext(DropdownContext)

  return (
    <StyledDropdownContent
      aria-label='content-dropdown'
      isShow={show}
      overrideWidth={overrideWidth}
      positionDropdown={positionDropdown}
      {...restProps}
    />
  )
}

export default DropdownContent
